module.exports = __webpack_public_path__ + "img/facts-suites.7cd3fd23.svg";